import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';
import { options } from 'common/components/ContentEditor/options';
import {
    unwrapBlockquote,
    unwrapList,
} from 'common/components/ContentEditor/utils/editorHelpers';
import {
    IToolbarButtonProps,
    ToolbarButton,
} from 'common/components/ContentEditor/components/EditorToolbar/ToolbarButton';

export const ToolbarParagraph = ({ ...other }: IToolbarButtonProps) => {
    const editor = useContentEditor();

    return (
        <ToolbarButton
            active={editor.api.some({ match: { type: options.p.type } })}
            onMouseDown={(event) => {
                event.preventDefault();

                if (!editor.selection) return;

                unwrapList(editor);
                unwrapBlockquote(editor);

                editor.tf.setNodes({
                    type: options.p.type,
                } as never);
            }}
            {...other}
        />
    );
};
